export default {
  backendUrl: function() {
    if (process.env.NODE_ENV === 'development') {
      return 'http://192.168.34.33:3000/api/';
    } else {
      return '/api/';
    }
  },
  googleApiKey: function() {
    if (process.env.NODE_ENV === 'development') {
      return 'AIzaSyCc2UDXiUdgLkl66sKvJNYK16k9QmQ6llc';
    } else {
      //return 'AIzaSyCc2UDXiUdgLkl66sKvJNYK16k9QmQ6llc';
      return 'AIzaSyAwdjGb10ciDmYdIZBLxQdMJkoujq7k61k';
    }
  },
  stripePublicKey: function() {
    if (process.env.NODE_ENV === 'development') {
      return 'pk_test_C2zMuZw6DDWeolX8JLzgkDoI';
    } else {
      //return 'pk_test_C2zMuZw6DDWeolX8JLzgkDoI';
      return 'pk_live_0GI1n81JYAHV1Ca2qqfkOFkp';
    }
  }
};
